module.exports = __webpack_public_path__ + "static/img/Ok-z@2x.33d5445.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/toefl/Ok-z@2x.png
// module id = FTBq
// module chunks = 96